import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.60336 2.50652C8.06005 2.56361 8.38398 2.9801 8.3269 3.43678L8.02732 5.83342H13.0143L13.3398 3.23006C13.3969 2.77338 13.8133 2.44944 14.27 2.50652C14.7267 2.56361 15.0507 2.9801 14.9936 3.43678L14.694 5.83342H16.6667C17.1269 5.83342 17.5 6.20652 17.5 6.66675C17.5 7.12699 17.1269 7.50009 16.6667 7.50009H14.4857L13.8607 12.5001H16.6667C17.1269 12.5001 17.5 12.8732 17.5 13.3334C17.5 13.7937 17.1269 14.1668 16.6667 14.1668H13.6523L13.3269 16.7701C13.2698 17.2268 12.8533 17.5507 12.3966 17.4937C11.94 17.4366 11.616 17.0201 11.6731 16.5634L11.9727 14.1668H6.98565L6.66023 16.7701C6.60315 17.2268 6.18665 17.5507 5.72997 17.4937C5.27329 17.4366 4.94935 17.0201 5.00644 16.5634L5.30601 14.1668H3.33333C2.8731 14.1668 2.5 13.7937 2.5 13.3334C2.5 12.8732 2.8731 12.5001 3.33333 12.5001H5.51435L6.13935 7.50009H3.33333C2.8731 7.50009 2.5 7.12699 2.5 6.66675C2.5 6.20652 2.8731 5.83342 3.33333 5.83342H6.34768L6.6731 3.23006C6.73019 2.77338 7.14668 2.44944 7.60336 2.50652ZM7.81899 7.50009L7.19399 12.5001H12.181L12.806 7.50009H7.81899Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }